<template>
  <transition name="fade">
    <div class="fabric-dialog">
      <div class="wrapper">
        <div class="dialog-header">
          <div class="close" @click="clickOutside">
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.41425 7.667L13.7072 2.374C14.0982 1.983 14.0982 1.351 13.7072 0.959998C13.3162 0.568998 12.6842 0.568998 12.2933 0.959998L7.00025 6.253L1.70725 0.959998C1.31625 0.568998 0.68425 0.568998 0.29325 0.959998C-0.09775 1.351 -0.09775 1.983 0.29325 2.374L5.58625 7.667L0.29325 12.96C-0.09775 13.351 -0.09775 13.983 0.29325 14.374C0.48825 14.569 0.74425 14.667 1.00025 14.667C1.25625 14.667 1.51225 14.569 1.70725 14.374L7.00025 9.081L12.2933 14.374C12.4882 14.569 12.7443 14.667 13.0002 14.667C13.2562 14.667 13.5122 14.569 13.7072 14.374C14.0982 13.983 14.0982 13.351 13.7072 12.96L8.41425 7.667Z"
                    fill="#969696"/>
            </svg>
          </div>
        </div>
        <div class="color-fabric" v-click-outside="clickOutside">
          <div class="toolbar">
            <transition name="fade">
              <button class="btn-apply" v-if="applyButton" @click="applyChanges">
                <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2.20711 5.2929C1.81658 4.90238 1.18342 4.90238 0.792893 5.2929C0.402369 5.68343 0.402369 6.31659 0.792893 6.70712L5.79289 11.7071C6.19802 12.1122 6.86002 12.0948 7.24329 11.669L16.2433 1.66897C16.6128 1.25846 16.5795 0.626173 16.169 0.256714C15.7585 -0.112745 15.1262 -0.0794662 14.7567 0.331044L6.46181 9.5476L2.20711 5.2929Z"
                        fill="white"/>
                </svg>
                Zastosuj kolor
              </button>
            </transition>
            <div class="swatches"
                 :class="{ 'hide-small' : selectedGroup, 'hide-all' : 0, 'collapsed' : showGroups, 'clickable' : !applyButton}"
                 @click="selectedGroup ? applyButton ? showGroups : showGroups = !showGroups : false">
        <span class="selected-color" :class="{'empty' : !getGroupImage}">
          <transition name="fade">
            <img v-if="getGroupImage" :src="getGroupImage"/>
          </transition>
        </span>
              <span class="tip" v-if="showGroups && !applyButton">Wybierz kolor z palety</span>

              <ul v-if="!showGroups">
                <li v-for="attribute in attributes" v-if="selectedGroup && attribute[0].group.id !== selectedGroup">
                  <img :src="attribute[0].group.image" class="exclude-click"/>
                </li>
              </ul>

              <span class="collapsing" :class="{ 'collaps' : showGroups }" v-if="selectedGroup">
                      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683418 12.0976 1.31658 11.7071 1.70711L6.70711 6.70711C6.31658 7.09763 5.68342 7.09763 5.29289 6.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893Z"
                              fill="#3C3C3C"/>
                      </svg>
                    </span>
            </div>
          </div>
          <div class="collection" ref="collectionContainer" v-if="attributes">
            <transition
                :enter-active-class="!isMobile ? 'animate__animated animate__slideInDown' : 'animate__animated animate__fadeIn animate__faster'"
                :leave-active-class="!isMobile ? 'animate__animated animate__slideOutUp' : 'animate__animated animate__fadeOut animate__faster'"
                mode="out-in">
              <div class="options" id="colorOptions" v-show="showGroups" data-simplebar
                   data-simplebar-auto-hide="false">
                <ul>
                  <li v-for="attribute in attributes" @click="selectedGroup = attribute[0].group.id, applyChanges()"
                      class="option"
                      :class="{ 'selected' : attribute[0].group.id === selectedGroup}">
                    <img :src="attribute[0].group.image"/>
                    {{ attribute[0].group.name }}
                  </li>
                </ul>
              </div>
            </transition>
            <transition
                :enter-active-class="!isMobile ? 'animate__animated animate__slideInDown' : 'animate__animated animate__fadeIn animate__faster'"
                :leave-active-class="!isMobile ? 'animate__animated animate__slideOutUp' : 'animate__animated animate__fadeIn animate__faster'"
                mode="out-in">
              <div class="options" id="fabricOptions" v-if="showColors && !showGroups" data-simplebar
                   data-simplebar-auto-hide="false">
                <ul>
                  <li v-for="attribute in attributes[selectedGroup]"
                      class="option no-clickable rich"
                      :class="{ 'selected' : attribute.id === selectedFabric}">
                    <image-item :source="attribute.image" class="image"/>
                    <div>
                      <div>{{ attribute.name }}</div>
                      <p class="desc">{{ attribute.description }}</p>
                      <p class="order" @click="openProductCartPreview(attribute)">Zamów bezpłatną próbkę</p>
                    </div>
                    <button v-if="attribute.product" class="btn-info" @click.stop="openProductPreview(attribute)">
                      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.5 0C9.81371 0 12.5 2.68629 12.5 6C12.5 9.31371 9.81371 12 6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0ZM6.5 5C5.98716 5 5.56449 5.38604 5.50673 5.88338L5.5 6V9C5.5 9.55229 5.94772 10 6.5 10C7.01284 10 7.43551 9.61396 7.49327 9.11662L7.5 9V6C7.5 5.44772 7.05228 5 6.5 5ZM5.5 2L7.5 2V4L5.5 4V2Z"
                              fill="#3C3C3C"/>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
          <div style="padding: 25% 0; text-align: center; color: #969696" v-else>
            Wczytywanie tkanin
          </div>
          <transition name="slide">
            <ProductPreview v-if="productPreview" :attribute="productToPreview" @close="closeProductPreview"/>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import imageItem from './ImageItem';
import ProductPreview from "../ProductPreview";
import clickOutside from '../../../directives/clickOutside'

export default {
  name: "FabricDialog",
  components: {imageItem, ProductPreview},
  directives: {clickOutside},
  props: ['open'],
  data() {
    return {
      attributes: null,
      selectedGroup: null,
      selectedGroupTemp: null,
      selectedFabric: null,
      selectedFabricTemp: null,
      applyButton: false,
      showGroups: true,
      showColors: false,
      productPreview: false,
      productToPreview: null,
      addToCartProduct: null,
      windowWidth: window.innerWidth,
      customFabric: null,
      customFabricText: false,
      showDialog: true,
      allowClose: false
    }
  },
  computed: {
    ...mapGetters({
      getFabrics: 'customizer/getFabrics'
    }),
    isMobile() {
      return this.windowWidth <= 680
    },
    getGroupImage() {
      if (this.selectedGroup) {
        return this.attributes[this.selectedGroup][0].group.image || null
      }
    },
  },
  mounted() {
    if (!this.getFabrics) {
      this.fetchAttributeFabric().then((res) => {
        this.getAttributes(res)
      })
    } else {
      this.getAttributes(this.getFabrics)
    }

    setTimeout(() => {
      this.allowClose = true
    }, 100)
  },
  methods: {
    ...mapActions('customizer', ['fetchAttributeFabric', 'addToCart']),
    getAttributes(data) {
      let options = JSON.parse(JSON.stringify(data))
      options = options.reduce(function (r, a) {
        r[a.group.id] = r[a.group.id] || [];
        r[a.group.id].push(a);
        return r;
      }, Object.create(null));

      this.attributes = options
    },
    setOption(option) {
      this.selectedFabric = option
    },
    applyChanges() {
      if (this.selectedGroup) {
        this.showGroups = false
        this.showColors = true
      }

      this.applyButton = false
    },
    openProductCartPreview(product) {
      this.productPreview = true
      this.productToPreview = {...product, addToCart: true}
    },
    openProductPreview(product) {
      this.productPreview = true
      this.productToPreview = product
    },
    closeProductPreview() {
      this.productPreview = false
      this.productToPreview = null
      this.addToCartProduct = null
    },
    clickOutside(e) {
      const container = document.querySelector('.color-fabric')
      if (!this.allowClose || e.target.className === 'exclude-click') {
        return
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.fabric-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, .5);
  z-index: 9999;

  cursor: default;

  display: flex;
  justify-content: center;
  align-items: center;

  .wrapper {
    font-family: "neue-haas-grotesk-display", sans-serif;
    background: #fff;
    box-shadow: 0 10px 12px rgba(26, 26, 26, 0.1);
    border-radius: 4px;
    width: 100%;
    max-width: 450px;
    box-sizing: border-box;

    .dialog-header {
      padding: 15px 15px 0 15px;
      display: flex;
      justify-content: flex-end;
      @media (max-width:480px) {
        padding: 0;
      }
      .close {
        width: 50px;
        height: 37px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
          path {
            transition: all .2s;
          }
        }

        &:hover {
          svg {
            path {
              fill: #333
            }
          }
        }
      }
    }

    @media (max-width: 480px) {
      margin: 0 20px;
      padding: 20px;
    }

    h3 {
      font-size: 22px;
      margin: 0 0 15px 0;
    }

    p {
      line-height: 22px;
      font-size: 14px;
    }

    .buttons {
      text-align: right;
      margin: 15px 0 0 0;

      @media (max-width: 480px) {
        display: flex;
        justify-content: space-between;
      }

      button {
        padding: 10px 30px;
        display: inline-flex;
        align-items: center;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        transition: all .2s;
        cursor: pointer;

        &.confirm {
          background: #252525;
          border: 2px solid #252525;
          color: #fff;

          &:hover {
            background: #303030;
          }
        }

        &.cancel {
          border: 2px solid #252525;
          color: #252525;
          background: #fff;
          margin: 0 15px 0 0;

          &:hover {
            background: #f1f1f1;
          }
        }
      }


    }

    .color-fabric {
      overflow: hidden;
      position: relative;
      height: 100%;

      @media (max-width: 680px) {
        overflow: visible;
      }

      .toolbar {
        background: #fff;
        position: relative;
        z-index: 1;

        @media (max-width: 680px) {
          position: sticky;
          top: 0;
        }

        .btn-apply {
          padding: 12px 40px;
          display: inline-flex;
          align-items: center;
          background: #74C7ED;
          color: #fff;
          border: 0;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          transition: all .2s;
          cursor: pointer;
          position: absolute;
          top: 50%;
          right: 15%;
          transform: translateY(-50%);
          z-index: 1;

          @media (max-width: 768px) {
            padding: 12px 20px;
          }

          svg {
            width: 18px;
            height: auto;
            transition: all .2s;
            margin-right: 10px;

            path {
              fill: #fff;
            }
          }
        }

        .tip {
          padding: 5px 0;
          z-index: 1;
          background: #fff;
          color: #969696;
          margin-left: auto;
        }

        .selected-color {
          display: inline-flex;
          width: 52px;
          height: 52px;
          margin-right: 15px;
          border: 1px solid #fff;

          &.empty {
            border: 1px solid #eee;
            border-radius: 100%;
          }

          @media (max-width: 768px) {
            width: 42px;
            height: 42px;
          }
        }

        .swatches {
          display: flex;
          align-items: center;
          padding: 25px 15% 25px 10%;
          border-bottom: 1px solid #efefef;

          &.clickable {
            cursor: pointer;
          }

          ul {
            margin: 0 auto;
            list-style: none;
            padding: 0;
            display: flex;
            align-items: center;
            cursor: pointer;

            //&.hide-small {
            //  //li:not(:first-child) {
            //  //  opacity: 0;
            //  //}
            //}
            //
            //&.hide-all {
            //  li {
            //    opacity: 0;
            //  }
            //}
            //
            //&.collapsed {
            //  li.normal {
            //    opacity: 0;
            //    &.selected {
            //      opacity: 1;
            //      margin-top: 7px;
            //    }
            //  }
            //}

            li {
              width: 23px;
              height: 23px;
              margin: 0 10px 0 0;
              //transition: all .2s;
              display: none;

              &:nth-child(-n+5) {
                display: inline-block;
              }

              &:last-child {
                padding: 0;
              }

              img {
                max-width: 100%;
                height: auto;
              }

              &.selected {
                transform: scale(1.75);
                order: -1;
                margin-right: 20px;
                margin-top: 7px;
              }
            }
          }

          .collapsing {
            margin-left: auto;
            transition: all .2s;
            transform-origin: 6px center;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            height: 25px;

            &.collaps {
              transform: rotate(180deg);
            }
          }
        }

      }

      .collection {
        overflow: hidden;
        position: relative;
        height: 465px;
        flex: 1;
        margin: 10px 0 20px 0;


        .options {
          margin: 0;
          overflow-y: auto;
          width: 100%;
          box-sizing: border-box;
          position: absolute;
          background: #fff;
          padding: 10px 20px;

          @media (max-width: 480px) {
            position: relative;
            padding: 15px 0;
          }

          height: 100%;

          ul {
            padding: 0;
            margin: 0;
          }

          .option {
            display: flex;
            align-items: center;
            padding: 15px;
            border: 1px solid #efefef;
            border-radius: 5px;
            margin-bottom: 10px;
            cursor: pointer;
            font-weight: 600;
            font-size: 16px;
            color: #3C3C3C;
            transition: all .2s;

            @media (max-width: 480px) {
              font-size: 14px;
            }

            .image-placeholder {
              width: 70px;
              height: 70px;
              border-radius: 100%;
              display: inline-block;
              background: #eee;
              z-index: 1;
              margin-right: 15px;
            }

            label {
              display: flex;
              align-items: center;
            }

            input {
              display: none;
            }

            p.desc {
              font-size: 12px;
              font-weight: normal;
              color: #969696;
              margin: 0;
              line-height: 16px;
            }

            p.order {
              font-weight: 600;
              font-size: 12px;
              color: #3C91B8;
              margin: 0;
              line-height: 16px;
              cursor: pointer;
            }

            .price-diff {
              font-size: 12px;
              color: #969696;
            }

            .btn-info {
              margin-left: auto;
              width: 32px;
              height: 32px;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #efefef;
              border-radius: 4px;
              transition: all .2s;
              cursor: pointer;
              background: #fff;
              padding: 0;

              &:hover {
                background: #f5f5f5;
              }

              svg {
                width: 13px;
                height: 12px;
                display: inline-block;
              }
            }

            img, .image {
              margin-right: 15px;
            }

            img, .image::v-deep img {
              width: 23px;
              height: 23px;
            }

            &.selected {
              border: 1px solid #3c3c3c;
            }

            &.selected-previously {
              border: 1px solid #C8C8C8;
            }

            &.rich {
              img, .image::v-deep img {
                width: 70px;
                height: 70px;
                border-radius: 70px;
              }
            }

            &.no-action {
              &:hover {
                cursor: default !important;
              }
            }

            &.with-input {
              & > div {
                width: 100%;
              }

              input {
                display: block;
                width: 100%;
                border: 1px solid #EFEFEF;
                border-radius: 4px;
                color: #969696;
                font-size: 14px;
                padding: 10px 12px !important;
                margin: 8px 0;
                box-sizing: border-box;
                line-height: normal !important /*line-height: 2.3;*/
              ;
              }

              .desc {
                font-size: 14px;
                line-height: 20px;
                color: #3C3C3C;
              }

              .desc-info {
                font-weight: 500;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: 0.4px;
                color: #D3A221;
                margin: 0;
              }
            }

            cursor: default;

            &:not(.no-clickable):hover {
              border: 1px solid #3c3c3c;
              cursor: pointer;
            }
          }
        }
      }

    }

    .list-enter,
    .list-leave-to {
      visibility: hidden;
      height: 0;
      margin: 0;
      padding: 0;
      opacity: 0;
    }

    .list-enter-active,
    .list-leave-active {
      transition: all 0.3s;
    }

    //.fade-enter-active, .fade-leave-active {
    //  transition: opacity .2s;
    //}
    //
    //.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    //  opacity: 0;
    //  position: absolute;
    //}

    .slide-leave-active,
    .slide-enter-active,
    .slide-leave-to {
      transition: transform .5s;
    }

    .slide-enter {
      transform: translate(100%, 0);
      position: absolute;
      @media (max-width: 480px) {
        position: fixed;
      }
    }

    .slide-leave-to {
      transform: translate(100%, 0);
      position: absolute;
      @media (max-width: 480px) {
        position: fixed;
      }
    }

  }
}
</style>
